import { createSelector } from "reselect";

import { getLegCards } from "@app/modules/results/selectors/leg-cards/get-leg-cards";

import { getTrips, getMaxPriceFilter } from "../state-accessors";

export const getFilteredLegCarIdsByMaxPrice = createSelector(
  [getLegCards, getTrips, getMaxPriceFilter],
  (leg_cards, trips, max_price) => {
    const leg_card_ids = Object.keys(leg_cards);

    if (max_price === null) {
      return leg_card_ids;
    }

    return leg_card_ids.filter(id => {
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip = trips[leg_cards[id][0]];
      // TODO: UDMV4
      // eslint-disable-next-line
      // @ts-ignore
      return trip.prices.some(price => price.prices.total <= max_price);
    });
  }
);
